/**
 * What a scheduled spot actually cost the advertiser.
 *
 * station_schedules.revenue_value is the order's charged amount split across its spots (0 on a
 * free/100% promo order); ratecard_value is the rate's list price, used for legacy rows written
 * before revenue_value existed. CPM_value is the impressions' value at the rate's CPM (e.g. $1.00
 * for 100 impressions at a $10 CPM) and is NOT what was charged. Same rule as the backend receipt
 * (get_order_receipt.schedule_row_cost).
 */
export function scheduleSpotCost(schedule: {
  revenue_value?: number | string | null
  ratecard_value?: number | string | null
}): number {
  for (const raw of [schedule?.revenue_value, schedule?.ratecard_value]) {
    if (raw === null || raw === undefined || raw === "") continue
    const value = Number(raw)
    if (Number.isFinite(value)) return value
  }
  return 0
}
